module.exports = __webpack_public_path__ + "static/media/icon.d9561ea1.svg";


//////////////////
// WEBPACK FOOTER
// ../images/icon.svg
// module id = 662
// module chunks = 0